'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n       {\n        border-top-right-radius: 2px;\n        border-bottom-right-radius: 2px;\n        margin-right: 8px;\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n       {\n        border-top-left-radius: 2px;\n        border-bottom-left-radius: 2px;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 0;\n      margin-right: 0;\n      height: 40px;\n      background-color: ", ";\n      border: 0;\n      cursor: default;\n      pointer-events: none;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      align-items: center;\n      font-size: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n  transition: background-color 0.25s, border-bottom-color 0.25s, color 0.25s;\n  \n\n  ", "\n\n  ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('../../../styled');

var _place = require('../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _vars = require('../../../styled/vars');

var _vars2 = _interopRequireDefault(_vars);

var _mediaTemplates = require('../../../styled/mediaTemplates');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Item = exports.Item = _styledComponents2.default.li(_templateObject(), function (props) {
  return props.place === _place2.default.Header && _styledComponents.css(_templateObject2(), _vars2.default.fontSizeSm);
}, function (props) {
  return props.headerDisabled && _styledComponents.css(_templateObject3(), _styled.colors.silver.light);
}, function (props) {
  return props.firstHeaderDisabled && _styledComponents.css(_templateObject4());
}, function (props) {
  return props.lastHeaderDisabled && _styledComponents.css(_templateObject5());
});